import React from "react";
import { useState, useEffect } from "react";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { vehicle_type_option } from "../../../utilities";
import Select from "react-select";
import FileUpload from "../../Constant/fileupload";
import { createModelApi, editModelApi } from "../../../services/VehicleService";
import { getBrandModelApi } from "../../../services/SearchService";
const AddModelModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [brandOption, setBrandOption] = useState([]);
  const [selecetdBrand, setSelectedBrand] = useState(null);
  const [brandLoading, setBrandLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [form, setForm] = useState({
    name: "",
    brand: "",
    model_type: "",
    model_size: "",
    image: null,
  });
  const [error, setError] = useState({});

  const getBrand = (brandIndex) => {
    setBrandLoading(true);
    getBrandModelApi()
      .then((res) => {
        const dataList =
          res?.data?.results?.map((item) => ({
            label: item?.label,
            value: item?.value,
          })) || [];

        setBrandOption(dataList);

        setSelectedBrand(
          dataList.find((item) => item?.value == brandIndex) || null
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setBrandLoading(false);
      });
  };

  useEffect(() => {
    if (visible) {
      getBrand(data?.brand);
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        name: data?.name || "",
        model_type: data?.model_type || "",
        image: data?.image || null,
      });
      setSelectedVehicle(
        vehicle_type_option.find((item) => item?.label == data?.model_size) ||
          null
      );
    } else {
      setForm({
        name: "",
        brand: "",
        model_type: "",
        model_size: "",
        image: null,
      });
      setSelectedVehicle(null);
      setSelectedBrand(null);
    }

    setError({});
  };

  useEffect(() => {
    setForm({
      ...form,
      model_size: selectedVehicle?.value || "",
      brand: selecetdBrand?.value || "",
    });
    if (error?.model_size && selectedVehicle?.value) {
      setError({ ...error, model_size: "" });
    }
    if (error?.brand && selecetdBrand?.value) {
      setError({ ...error, brand: "" });
    }
  }, [selectedVehicle, selecetdBrand]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (value && error[name]) {
      setError({ ...error, [name]: "" });
    }
  };

  const createModel = (data) => {
    setLoading(true);
    createModelApi(data)
      .then((res) => {
        toast.success("Model Created Successfully");
        handleReset();
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const editModel = (payload) => {
    setLoading(true);
    editModelApi(data?.id || "", payload)
      .then((res) => {
        toast.success("Model update Successfully");
        handleReset();
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSubmit = () => {
    let error = {};
    if (!form?.name) {
      error.name = "Name Required";
    }
    if (!form?.brand) {
      error.brand = "Brand Required";
    }
    if (!form?.model_type) {
      error.model_type = "Required Field";
    }
    if (!form?.model_size) {
      error.model_size = "Required Field";
    }

    setError(error);
    if (Object.entries(error).length == 0) {
      const formData = new FormData();

      formData.append("name", form.name || "");
      formData.append("brand", form.brand || "");
      formData.append("model_size", form.model_size || "");
      formData.append("model_type", form.model_type || "");

      if (form.image instanceof File) {
        formData.append("image", form.image);
      }

      if (data) {
        editModel(formData);
      } else {
        createModel(formData);
      }
    }
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{data ? "Edit Model" : "Add Model"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-1 g-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Model Name</label>
              <input
                type="text"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                name="name"
                value={form?.name}
                placeholder="Tata"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error?.name}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Brand</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="Select Vehicle"
                options={brandOption}
                value={selecetdBrand}
                onChange={setSelectedBrand}
              />
              {error?.brand && (
                <small className="text-danger">{error?.brand}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Model Type</label>
              <input
                type="text"
                name="model_type"
                className={`form-control ${
                  error?.model_type ? "is-invalid" : ""
                }`}
                value={form?.model_type}
                placeholder="model type"
                onChange={handleInputChange}
              />
              {error?.model_type && (
                <small className="text-danger">{error?.model_type}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Model Size</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="Select Vehicle"
                options={vehicle_type_option}
                value={selectedVehicle}
                onChange={setSelectedVehicle}
              />
              {error?.model_size && (
                <small className="text-danger">{error?.model_size}</small>
              )}
            </div>

            <div className="col-12">
              <label className="form-label text-dark">Model Image</label>
            </div>
            <div className="col-6 mt-0">
              <FileUpload
                label="Drag & drop File (max size 3MB)"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form.image}
                onChange={(files) =>
                  setForm((prev) => ({ ...prev, image: files }))
                }
              />
            </div>
            <div className="col-6 mt-0">
              <div
                className="card shadow-sm"
                style={{ height: "100px", overflow: "hidden" }}
              >
                {form?.image ? (
                  <img
                    src={
                      form?.image instanceof File
                        ? URL.createObjectURL(form.image)
                        : form?.image
                        ? `${process.env.REACT_APP_BASE_URL}${form.image}`
                        : null
                    }
                    alt="Image Preview"
                    style={{
                      objectFit: "contain",
                      maxHeight: "100%",
                      minWidth: "100%",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center h-100"
                    style={{
                      backdropFilter: "blur(4px)",
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }}
                  >
                    <span className="text-secondary fw-semibold">
                      Image Not Available
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-dark"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {data ? "Update" : "Submit"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddModelModal;
